export interface contactsInterface {
    contact_id: number;
    name: string;
    phone: string;
    picture_url: string;
}

export interface searchFiltersInterface {
    type: string;
    name: string;
    from_last_modified: undefined | number;
    to_last_modified: undefined | number;
    range: boolean;
    parent_name: string | null;
    parent_id: null | number;
    is_trash: boolean;
    is_favorite: boolean;
    dateOption?: CalendarOptions;
}

export enum CalendarOptions {
    TODAY = "امروز",
    YESTERDAY = "دیروز",
    WEEK = "۷ روز اخیر",
    MONTH = "۳۰ روز اخیر",
    CUSTOM = "بازه دلخواه",
    ALL_DAYS = "همه زمان ها"
}

export enum SearchPageType {
    MY_FILE = "myFile",
    WITH_SHARE_ME = "withShareMe"
}
